import { createContext, useContext } from 'react';

export const XYChartLegendHiddenContext = createContext<boolean>(false);

XYChartLegendHiddenContext['displayName'] = 'XYChartLegendHiddenContext';

export const useLegendHidden = () => useContext(XYChartLegendHiddenContext);
